import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Container, Group, Stack } from '@mantine/core'
import MainCommonView from '../MainCommonView'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
import ViewNotifiedUsers from './ViewNotifiedUsers'
import swalAlert from '../../../utils/helpers/swalAlert'
import useModal from '../../../utils/hooks/useModal'
import Modal from '../../modal/Modal'
import UsersAccessModule from './UsersAccessModule'
import AddUserFromModal from './AddUserFromModal'
import AppSection from '../../../component/layout/AppSection.tsx'
import { themeCfg } from '../../../theme/theme.ts'
import AppHeaderView from '../../../component/layout/AppHeaderView.tsx'
import AppContainer from '../../../component/layout/AppContainer.tsx'
import AppSimpleGrid from '../../../component/layout/AppSimpleGrid.tsx'

const NotificationsCommonView = ({
  header,
  canGetAccessUses,
  getUsersAccessService,
  getAllNotificationModules,
  removeUserNotificationModuleService,
  canDeleteUser,
  addUserNotificationModuleService,
  canAddUser,
}) => {
  const { formatMessage: msg } = useIntl()

  const { isShowing, toggle } = useModal()
  const { isShowingInfo, toggleInfo } = useModal()

  const [notification, setNotification] = useState({})

  const dataFacade = useHandlerBasicActions({
    getAll: getAllNotificationModules,
  })

  const headerOptions = {
    title: msg({ id: 'notifications' }),
    handlerHeaderActions: {
      secondaryButton: canGetAccessUses && toggleInfo,
      secondaryButtonText: 'button.users.view',
      secondaryButtonIcon: 'pi-eye',
    },
  }

  const handleAddUser = async (userId) => {
    const resp = await addUserNotificationModuleService(notification?.id, {
      userId,
    })
    if (resp) {
      dataFacade.reload()
      toggle()
    }
  }

  const handleDelete = async (idModule, userId) => {
    const confirm = await swalAlert.warning(
      msg({ id: 'swal.title.delete' }),
      msg({ id: 'button.cancel' }),
      msg({ id: 'button.delete' }),
    )
    if (confirm?.isConfirmed) {
      const response = await removeUserNotificationModuleService(
        idModule,
        userId,
      )
      if (response) dataFacade.reload()
    }
  }

  const toggleAddUserToModule = (data) => {
    toggle()
    setNotification(data)
  }

  const dataView =
    dataFacade?.data?.resp?.length > 0 &&
    dataFacade?.data?.resp?.map((notific) => (
      <ViewNotifiedUsers
        key={notific?._id}
        notification={notific}
        toggleAddUserToModule={toggleAddUserToModule}
        handleDelete={handleDelete}
        canDeleteUser={canDeleteUser}
        canAddUser={canAddUser}
      />
    ))

  return (
    <AppSimpleGrid cols={3} breakpoint="xl">
      {dataView}

      <Modal
        isShowing={isShowing}
        hide={toggle}
        width="90%"
        maxWidth="550px"
        title={`${msg({ id: 'user.add.module' })} - ${notification?.action ? msg({ id: notification.action }) : ''}`}
        context={<AddUserFromModal handleAddUser={handleAddUser} />}
      />

      <Modal
        isShowing={isShowingInfo}
        hide={toggleInfo}
        width="90%"
        maxWidth="750px"
        title={msg({ id: 'users.access.fuelstations' })}
        context={<UsersAccessModule getService={getUsersAccessService} />}
      />
    </AppSimpleGrid>
  )
}

export default NotificationsCommonView
